"use client";

// src/index.cc.tsx
import * as React from "react";
var RealSimulatePreloadedQuery;
var SimulatePreloadedQuery = (props) => {
  if (!RealSimulatePreloadedQuery) {
    RealSimulatePreloadedQuery = React.lazy(
      () => import("./SimulatePreloadedQuery.cc.js")
    );
  }
  return /* @__PURE__ */ React.createElement(RealSimulatePreloadedQuery, { ...props });
};
export {
  SimulatePreloadedQuery
};
export const built_for_browser = true;
//# sourceMappingURL=index.cc.js.map